import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideLayout, ViewMode } from '@gripp/shared-ui';
import React from 'react';
import { Outlet, useLocation } from 'react-router';
import { Profile } from '../../profile/components/profile';
import { AccountPage } from './components/accountPage';
import { SettingMenu } from './components/settingMenu';

export const Settings: React.FC = () => {
  // TODO: Crop Circle Redesign | Remove feature flag check after full rollout
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign | Return old Profile component when flag is OFF
  if (!isCropCircleRedesignEnabled) {
    return <Profile />;
  }

  // TODO: Crop Circle Redesign | Remove SettingsBase after full rollout
  return <SettingsBase />;
};

const SettingsBase: React.FC = () => {
  const location = useLocation();
  const isChildRoute = location.pathname !== '/settings';

  const leftColumn = {
    title: 'preferences.settings.title',
    mainComponent: <SettingMenu />,
  };

  const rightColumn = {
    title: 'accountPage.menu.accountPage',
    mainComponent: isChildRoute ? <Outlet /> : <AccountPage />,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
